<div class="topline">
  <h2>Blacklisted Users</h2>
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="blacklistSearch" (input)="onInput()">
  </mat-form-field>
</div>

<table mat-table [dataSource]="blacklist" class="table">
  <ng-container matColumnDef="index">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let item; let i = index">{{i + 1}}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let item">{{item.description || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="resourceType">
    <th mat-header-cell *matHeaderCellDef>Resource Type</th>
    <td mat-cell *matCellDef="let item">{{item.resourceType}}</td>
  </ng-container>

  <ng-container matColumnDef="resourceId">
    <th mat-header-cell *matHeaderCellDef>Identification</th>
    <td mat-cell *matCellDef="let item">{{item.resourceId}}</td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef>Created At</th>
    <td mat-cell *matCellDef="let item">{{item.createdAt | date:'medium'}}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <button mat-button color="warn" (click)="remove(item)">Remove</button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['index','description','resourceType','resourceId','createdAt','actions']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['index','description','resourceType','resourceId','createdAt','actions']"></tr>
</table>

<form class="add-row" [formGroup]="form">
  <mat-form-field appearance="outline" class="field">
    <mat-label>Description</mat-label>
    <input matInput formControlName="description">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Resource Type</mat-label>
    <mat-select formControlName="resourceType">
      <mat-option *ngFor="let type of resourceTypes" [value]="type">{{type.label}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Resource ID</mat-label>
    <input matInput [placeholder]="resourcePlaceholder()" formControlName="resourceId">
  </mat-form-field>

  <div class="actions">
    <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="add()">Add to Blacklist</button>
  </div>
</form>
